import React from 'react';
import Slider from 'react-slick';

export default function Brands({ data }) {
  const extendedData = data.length < 10 ? [...data, ...data] : data;

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    cssEase: 'linear',
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          speed: 3000,
          cssEase: 'linear',
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          speed: 2500,
          cssEase: 'linear',
        },
      },
    ],
  };

  return (
    <div className="py-1 py-md-2 brand-section gray-bg">
      <div className="container" data-aos="fade" data-aos-duration="1200" data-aos-delay="500">
        <Slider {...settings} className="slider-gap-50">
          {extendedData.map((item, index) => (
            <div key={index}>
              <div className="pt-3 pb-3 text-center d-flex align-items-center justify-content-center w-100">
                <img src={item.src} alt={item.alt} className="w-50" style={{ maxWidth: '80px', height: '80px' }} />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
